import type { SiteReadable } from "../../services/client/types.gen";

export const siteStatusTag: Record<
  NonNullable<SiteReadable["status"]>,
  { title: string; color: string }
> = {
  inactive: { title: "Inactive", color: "default" },
  active: { title: "Active", color: "green" },
  shadow: { title: "Shadow", color: "purple" },
};
